<template>
  <el-dialog
    :title="'管理论坛' + (DialogFormData.id ? ' : ' + DialogFormData.id : '')"
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="1000px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
  >
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="l('内容')" prop="content">
            <el-input
              type="textarea"
              :rows="3"
              :placeholder="
                mode == 'forum'
                  ? '有什么新鲜事想分享给大家'
                  : mode == 'discuss'
                  ? '发布你的评论'
                  : '发布你的回复'
              "
              :maxlength="mode == 'forum' ? '500' : '200'"
              :show-word-limit="true"
              :clearable="true"
              resize="none"
              :autosize="{ minRows: 3 }"
              v-model="DialogFormData.content"
              :disabled="Type == 'View'"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          v-if="
            mode == 'forum' &&
            (Type != 'View' || DialogFormData.img_array.length)
          "
          :span="24"
        >
          <ResourceListUpLoad
            key="img_array"
            ref="img_arrayUpload"
            prop="img_array"
            usage="forum"
            :initResourceUrl.sync="DialogFormData.img_array"
            :limit="9"
            size="small"
            :disabled="Type == 'View'"
          />
        </el-col>
        <el-col v-if="mode != 'forum'" :span="12">
          <el-form-item key="is_private" label="可见度" prop="is_private">
            <el-checkbox
              v-model="DialogFormData.is_private"
              :disabled="Type == 'View'"
              >仅对方可见</el-checkbox
            >
          </el-form-item>
        </el-col>
        <el-col v-if="mode == 'forum'" :span="12">
          <el-form-item :label="l('类型')" prop="tag_id">
            <el-select
              key="tag_id"
              v-model="DialogFormData.tag_id"
              :placeholder="l('请选择')"
              :disabled="Type == 'View'"
            >
              <el-option
                v-for="tag of $store.state.basicInfo.tagList.forum"
                :key="tag.id"
                :label="tag.name"
                :value="tag.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{l("取 消")}}</el-button>

      <template
        v-if="
          Type == 'View' && $store.getters.checkPermission('admin_forum.edit')
        "
      >
        <el-button type="warning" @click="Type = 'Edit'">{{l("修 改")}}</el-button>
        <el-button
          type="danger"
          v-show="DialogFormData.status != -1"
          @click="offline"
          >{{l("下架")}}</el-button
        >
        <el-button
          type="success"
          v-show="DialogFormData.status != 1"
          @click="online"
          >{{l("上架")}}</el-button
        >
      </template>

      <el-button
        v-if="Type == 'Create' || Type == 'Edit'"
        type="primary"
        @click="submitForm"
        >{{l("保 存")}}</el-button
      >
    </span>
    <RejectDialog ref="rejectDialog" @submitDialog="rejectCallback" />
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "CreateOrEditAdminForum",
  mixins: [dialogMixin],
  props: {
    mode: {
      type: String,
      default: "forum",
    },
  },
  data() {
    return {
      DialogFormData: {
        id: null,
        tag_id: null,
        content: "",
        img_array: [],
        is_private: false,
      },
      dialogRules: {
        content: [{ required: true, message: this.l("请输入")+this.l("内容"), trigger: "blur" }],
      },
    };
  },
  methods: {
    BeforeShow() {
      return new Promise((resolve, reject) => {
        let requestUrl = "";
        if (this.mode == "forum") {
          requestUrl = "/api/admin_forum/post";
        } else if (this.mode == "discuss") {
          requestUrl = "/api/admin_forum/discuss";
        }

        this.axios
          .get(`${requestUrl}/${this.DialogFormData.id}/`)
          .then((response) => {
            response.img_array = JSON.parse(response.img_array);
            this.DialogFormData = response;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }
        let requestUrl = "";
        if (this.mode == "forum") {
          requestUrl = "/api/admin_forum/post";
        } else if (this.mode == "discuss") {
          requestUrl = "/api/admin_forum/discuss";
        }

        this.axios
          .put(`${requestUrl}/${this.DialogFormData.id}/`, {
            ...this.DialogFormData,
            img_array: JSON.stringify(this.DialogFormData.img_array),
          })
          .then((data) => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    },
    online() {
      this.$confirm(`是否${this.l("上架")}?`, "", {
        type: "warning",
      }).then(() => {
        let requestUrl = "";
        if (this.mode == "forum") {
          requestUrl = "/api/admin_forum/post";
        } else if (this.mode == "discuss") {
          requestUrl = "/api/admin_forum/discuss";
        }
        this.axios
          .put(`${requestUrl}/${this.DialogFormData.id}/on/`)
          .then((data) => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    },
    offline() {
      this.$refs.rejectDialog.Show(
        Object.assign({}, this.DialogFormData, {
          dialogTitle: `下架`,
        })
      );
    },
    rejectCallback(item) {
      let requestUrl = "";
      if (this.mode == "forum") {
        requestUrl = "/api/admin_forum/post";
      } else if (this.mode == "discuss") {
        requestUrl = "/api/admin_forum/discuss";
      }
      this.axios
        .put(`${requestUrl}/${this.DialogFormData.id}/off/`, {
          comment: item.comment,
        })
        .then((data) => {
          this.$emit("submitDialog");
          this.Hide();
        });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-form--label-top .el-form-item__label {
  padding-bottom: 0;
}
</style>
